// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_PickupNotificationCreateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/entregas/pickup_notifications
 *
 * Record a customer outreach (pickup notification) for an item in PRONTO status.
 * Marks the item as alerted; a record in so_order_item_pickup_notifications is created.
 *
 * Fields:
 *   order_item_id — int, required (so_order_items PK)
 *   channel       — string, required ('whatsapp' | 'instagram' | 'manual' | 'outro' | 'portal')
 *   message_id    — int, optional (ID of the outgoing message if sent via WhatsApp/Instagram)
 *   notes         — string, optional (internal notes about the outreach)
 *
 * `channel: 'portal'` is the one value the controller does not just log — it
 * actually sends through Portal_trigger_php_service before writing the row
 * (plano-gatilhos-notificacao.md §4). That is exactly why the enum is closed
 * here: a typo like `portl` must be a validation failure, not a silently
 * logged phantom outreach that nobody actually sent.
 */
import { registerContract } from './validate'

export interface Orders_PickupNotificationCreateInput {
order_item_id: number
channel: string
message_id?: number
notes?: string
}

registerContract('Orders_PickupNotificationCreateInput', {
  order_item_id: { type: 'number',  required: true },
  channel:       { type: 'string',  required: true },
  message_id:    { type: 'number',  required: false },
  notes:         { type: 'string',  required: false },
})
